export const modalContent = {
  border: "solid 5px hsla(0, 0%, 0%, 0.5)",
  borderRadius: "10px",
  boxShadow: "0px 10px 50px hsla(0, 0%, 0%, 0.33)",
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
  transform: "translate(-50%, -50%)",
};
export const modalOverlay = { background: "hsla(0, 100%, 100%, 0.9)" };
